import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../../src/config";
const ForgotPassword = () => {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);

  //. handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");

    if (!email) {
      setError("Email is required");
      return;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Enter a valid email address");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}auth/forgotpassword`,
        { email }
      );

      if (response.data.success) {
        setSuccessMsg(response.data.message || "Password reset email sent");
        setEmail("");
      } else {
        setError(response.data.message || "Unable to send reset email");
      }
    } catch (err) {
      console.error("Forgot password error:", err);
      setError(err.response?.data?.message || "Unable to send reset email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="logincontainer">
      <div className="container">
        <div className="row justify-content-center">
          {/* Left side */}
          <div className="col-xxl-5 col-xl-4 col-lg-6 col-md-5 col-sm-12 col-12 align-self-center">
            <div className="logintextbox">
              <div className="loginheading">Remember your password?</div>
              <p>Sign in with your account credentials.</p>
              <Link to="/login" className="theme-btn signupbtn">
                Sign In
              </Link>
            </div>
          </div>

          {/* Right side */}
          <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-7 col-sm-12 col-12 align-self-center">
            <div className="loginbox">
              <div className="loginheading">Forgot Password</div>
              <p>Enter your email to receive password reset instructions.</p>

              <form onSubmit={handleSubmit}>
                {/* Email */}
                <div className="form-group">
                  <div className="formgroupinner">
                    <i className="fa fa-envelope-o"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Email ID"
                      name="email"
                      value={email}
                      // onChange={(e) => setEmail(e.target.value)}
                      onChange={(e) => setEmail(e.target.value.replace(/\s+/g, ""))}
                    />
                  </div>
                  {error && <small className="text-danger">{error}</small>}
                </div>

                {successMsg && (
                  <div className="alert alert-success">{successMsg}</div>
                )}

                <button
                  className="theme-btn loginbtn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </button>

                <div className="tex-start mt-3">
                  <div className="row gx-1 align-items-center">
                    <div className="col-12 text-end">
                      <Link to="/login" className="text-muted">
                        Back to Login
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
